<div *ngIf="templateGroup">
    <div *ngIf="level === HIGHEST_LEVEL" data-testid="mapping-group" [attr.data-group-title]="templateGroup.title">
        <div class="row-level highest-level level-border-bottom">
            <div class="column text-column">
                <div class="name-padding-left"></div>
                <span>
                    <inline-table-cell-edit
                        (save)="changeTemplateGroupTitle(templateGroup, $event)"
                        [value]="templateGroup.title"
                        #editableCell
                    ></inline-table-cell-edit>
                </span>
            </div>
            <div class="column value-column closing-column">
                <span class="value-column-cell-value" data-testid="group-closing">
                    {{ templateGroup.calculatedClosingBalance | finNumber }}
                </span>
            </div>
            <div class="column value-column">
                <span class="value-column-cell-value" data-testid="group-opening">
                    {{ templateGroup.calculatedOpeningBalance | finNumber }}
                </span>
            </div>
            <div class="column action-column action-column-padding">
                <menu-list-for-mapping
                    [item]="templateGroup"
                    [businessModel]="businessModel"
                    [cellComponent]="editableCell"
                    [isHighestLevelParent]="true"
                    (onClickEmitter)="onMenuActionClicked($event, templateGroup, undefined, groupIndex)"
                ></menu-list-for-mapping>
            </div>
        </div>

        <ng-container
            [ngTemplateOutlet]="sortedItems"
            [ngTemplateOutletContext]="{
                templateGroup: templateGroup,
                level: level,
                parent: this,
                delegate: delegate,
                flisLevelsIndentations: flisLevelsIndentations
            }"
        >
        </ng-container>
    </div>

    <div *ngIf="level !== HIGHEST_LEVEL">
        <mat-expansion-panel
            [expanded]="expandAll ? true : collapseAll && touched ? false : level === FIRST_LEVEL"
            hideToggle
            class="group-row"
            [class.hidden-group-row]="templateGroup.isHiddenGroup"
        >
            <mat-expansion-panel-header>
                <mat-panel-title class="row-level level-border-bottom">
                    <div class="column text-column">
                        <div class="name-padding-left"></div>

                        <ng-container *ngFor="let levelIndentations of levelsIndentations">
                            <div class="level-indentation"></div>
                        </ng-container>

                        <span
                            *ngIf="templateGroup.sortedItems.length > 0"
                            class="expanded-icon aumico-pattern-icon-arrow-down chevron-m"
                        >
                            <i class="chevron-icon"></i>
                        </span>
                        <span
                            *ngIf="templateGroup.sortedItems.length > 0"
                            class="collapsed-icon aumico-pattern-icon-arrow-right chevron-m"
                        >
                            <i class="chevron-icon"></i>
                        </span>
                        <div class="text-overflow">
                            <inline-table-cell-edit
                                [ngClass]="{ 'hidden-group': templateGroup.isHiddenGroup }"
                                (save)="changeTemplateGroupTitle(templateGroup, $event)"
                                [value]="templateGroup.title"
                                #editableCell
                            ></inline-table-cell-edit>
                        </div>
                    </div>
                    <div class="column value-column closing-column">
                        <span class="value-column-cell-value">{{
                            templateGroup.calculatedClosingBalance | finNumber
                        }}</span>
                    </div>
                    <div class="column value-column">
                        <span class="value-column-cell-value">{{
                            templateGroup.calculatedOpeningBalance | finNumber
                        }}</span>
                    </div>
                    <div class="column action-column action-column__container action-column-padding">
                        <mat-icon
                            *ngIf="templateGroupsList.length > 1"
                            class="move-icon"
                            (click)="moveGroup(templateGroup, false, $event)"
                            >south</mat-icon
                        >
                        <mat-icon
                            *ngIf="templateGroupsList.length > 1"
                            class="move-icon"
                            (click)="moveGroup(templateGroup, true, $event)"
                            >north</mat-icon
                        >
                        <span
                            *ngIf="isGroupDeletable(templateGroup)"
                            class="aumico-pattern-icon-remove"
                            (click)="removeGroup(templateGroup, $event)"
                        >
                            <i></i>
                        </span>

                        <menu-list-for-mapping
                            [item]="templateGroup"
                            [businessModel]="businessModel"
                            [cellComponent]="editableCell"
                            (onClickEmitter)="onMenuActionClicked($event, templateGroup, parentGroup, groupIndex)"
                        ></menu-list-for-mapping>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <ng-container
                [ngTemplateOutlet]="sortedItems"
                [ngTemplateOutletContext]="{
                    templateGroup: templateGroup,
                    level: level,
                    parent: this,
                    delegate: delegate,
                    flisLevelsIndentations: flisLevelsIndentations
                }"
            >
            </ng-container>
        </mat-expansion-panel>
    </div>
</div>
<ng-container *ngIf="level === HIGHEST_LEVEL">
    <div class="add-item-row">
        <span class="add-item">
            <button aum-icon-button icon="plus" color="basic" class="add-group-button" (click)="addNewGroup()">
                {{ 'aumico_templates_group_account_mapping_create_group' | i18next }}
            </button>
        </span>
        <span class="add-item">
            <button aum-icon-button icon="plus" color="basic" class="add-fli-button" (click)="addNewFLI()">
                {{ 'aumico_templates_group_account_mapping_add_fli' | i18next }}
            </button>
        </span>
        <span class="add-item">
            <button aum-icon-button icon="plus" color="basic" class="add-sub-fli-button" (click)="addNewSubFLI()">
                {{ 'aumico_templates_group_account_mapping_create_subfli' | i18next }}
            </button>
        </span>
    </div>
</ng-container>

<ng-template
    #sortedItems
    let-templateGroup="templateGroup"
    let-level="level"
    let-parent="parent"
    let-delegate="delegate"
    let-flisLevelsIndentations="flisLevelsIndentations"
>
    <ng-container
        *ngFor="
            let sortedItem of templateGroup.sortedItems;
            let sortedItemIndex = index;
            let first = first;
            let last = last
        "
    >
        <ng-container *ngIf="sortedItem.type != undefined; then itemsTemplate; else groupsTemplate"></ng-container>
        <ng-template #itemsTemplate>
            <ng-container
                [ngTemplateOutlet]="allItemsTemplate"
                [ngTemplateOutletContext]="{
                    item: sortedItem,
                    expandAll: expandAll,
                    itemIndex: sortedItemIndex,
                    collapseAll: collapseAll,
                    parentGroup: templateGroup,
                    parentFli: null,
                    flisLevelsIndentations: flisLevelsIndentations,
                    displayBorderBottom: true,
                    first: first,
                    last: last
                }"
            >
            </ng-container>
        </ng-template>
        <ng-template #groupsTemplate>
            <ng-container
                [ngTemplateOutlet]="templateGroups"
                [ngTemplateOutletContext]="{
                    group: sortedItem,
                    level: level,
                    parent: this,
                    delegate: delegate,
                    flisLevelsIndentations: flisLevelsIndentations,
                    i: sortedItemIndex
                }"
            >
            </ng-container>
        </ng-template>
    </ng-container>
</ng-template>

<ng-template
    #templateGroups
    let-group="group"
    let-level="level"
    let-parent="parent"
    let-delegate="delegate"
    let-flisLevelsIndentations="flisLevelsIndentations"
    let-i="i"
>
    <ng-container>
        <div *ngIf="group.isHeader; else isEmpty">
            <ng-container
                [ngTemplateOutlet]="header"
                [ngTemplateOutletContext]="{
                    item: group,
                    parent: templateGroup,
                    index: i
                }"
            >
            </ng-container>
        </div>
        <ng-template #isEmpty>
            <div *ngIf="group.isEmpty; else groupItem">
                <ng-container
                    [ngTemplateOutlet]="emptyRow"
                    [ngTemplateOutletContext]="{
                        item: group,
                        parent: templateGroup,
                        index: i
                    }"
                >
                </ng-container>
            </div>
            <ng-template #groupItem>
                <templates-group-account-mapping
                    [businessModel]="businessModel"
                    [reportLocale]="reportLocale"
                    [level]="level + 1"
                    [templateGroup]="group"
                    [groupIndex]="i"
                    [templateGroupsList]="templateGroup.sortedItems"
                    [parent]="this"
                    [touched]="touched"
                    [isCollapseButtonClicked]="collapseButtonClicked"
                    [delegate]="delegate"
                    [type]="type"
                    [hasPreviousData]="hasPreviousData"
                    [engine]="engine"
                    [parentGroup]="templateGroup"
                    [cashAndCashFli]="cashAndCashFli"
                    [profitOfTheYearFliName]="profitOfTheYearFliName"
                    [errorInProfitFli]="errorInProfitFli"
                    [isAutomaticTransferOfAnnualResultEnabled]="isAutomaticTransferOfAnnualResultEnabled"
                    [currentLanguage]="_currentLanguage"
                    [isCashFlowTypeForFliUsed]="isCashFlowTypeForFliUsed"
                    [disableEditingPreviousYearValue]="disableEditingPreviousYearValue"
                    [supportOperation]="supportOperation"
                    (addOrUpdateAccountInActiveReport)="onAddOrUpdateActiveReport($event)"
                    (fliOrGroupDeleted)="onFliOrGroupDeleted($event)"
                >
                </templates-group-account-mapping>
            </ng-template>
        </ng-template>
    </ng-container>
</ng-template>

<ng-template
    #accountTemplate
    let-account="account"
    let-item="item"
    let-accountIndex="accountIndex"
    let-flisLevelsIndentations="flisLevelsIndentations"
>
    <div #accountList [id]="item.name + accountIndex">
        <aumico-editable-account-form
            class="editable-cell"
            [flisLevelsIndentations]="flisLevelsIndentations"
            [account]="account"
            [hasPreviousData]="hasPreviousData"
            [parentType]="item.type"
            [parentName]="item.name"
            [businessModel]="businessModel"
            [disableEditingPreviousYearValue]="disableEditingPreviousYearValue"
            [errorInPreviousAnnualProfit]="errorInProfitFli"
            [supportOperation]="supportOperation"
            [isAutomaticTransferOfAnnualResultEnabled]="isAutomaticTransferOfAnnualResultEnabled"
            (saveAccount)="onAccountSaved(item, $event, account, accountIndex)"
            (removeAccount)="removeAccountFrom(item, accountIndex)"
            (cancelAccountCreation)="onCancelAccountCreation(item, accountIndex)"
            (onMenuActionClicked)="onMenuActionClicked($event, account, item, accountIndex)"
        >
        </aumico-editable-account-form>
    </div>
</ng-template>

<ng-template
    #allItemsTemplate
    let-expandAll="expandAll"
    let-collapseAll="collapseAll"
    let-item="item"
    let-parentGroup="parentGroup"
    let-parentFli="parentFli"
    let-itemIndex="itemIndex"
    let-flisLevelsIndentations="flisLevelsIndentations"
    let-displayBorderBottom="displayBorderBottom"
    let-first="first"
    let-last="last"
>
    <ng-container *ngIf="item.type === 'SUB_TOTAL'">
        <div class="row-level row-subtotal level-border-bottom">
            <div class="column text-column">
                <div class="name-padding-left"></div>
                <span class="text-overflow">
                    <inline-table-cell-edit
                        (save)="changeItemCaption(item, $event)"
                        [value]="item.caption"
                        #subTotalEditableCell
                    ></inline-table-cell-edit
                ></span>
            </div>
            <div class="column value-column closing-column">
                <span class="value-column-cell-value">{{ item.calculatedClosingBalance | finNumber }}</span>
            </div>
            <div class="column value-column">
                <span class="value-column-cell-value">{{ item.calculatedOpeningBalance | finNumber }}</span>
            </div>
            <div class="column action-column action-column__container action-column-padding">
                <mat-icon
                    *ngIf="templateGroup.sortedItems.length > 1 && !last"
                    class="move-icon"
                    (click)="moveGroupItem(item, false, $event)"
                    >south</mat-icon
                >
                <mat-icon
                    *ngIf="templateGroup.sortedItems.length > 1 && !first"
                    class="move-icon"
                    (click)="moveGroupItem(item, true, $event)"
                    >north</mat-icon
                >
                <span
                    *ngIf="isGroupItemDeletable(item)"
                    class="aumico-pattern-icon-remove"
                    (click)="removeItem(item, $event)"
                >
                    <i></i>
                </span>

                <menu-list-for-mapping
                    [item]="item"
                    [businessModel]="businessModel"
                    (onClickEmitter)="onMenuActionClicked($event, item, templateGroup, itemIndex)"
                ></menu-list-for-mapping>
            </div>
        </div>
    </ng-container>
    <ng-container
        *ngIf="item.type === 'EMPTY'"
        [ngTemplateOutlet]="emptyRow"
        [ngTemplateOutletContext]="{
                item,
                index: itemIndex,
                parent: templateGroup
            }"
    >
    </ng-container>
    <ng-container
        *ngIf="item.type === 'HEADER'"
        [ngTemplateOutlet]="header"
        [ngTemplateOutletContext]="{
                item,
                index: itemIndex,
                parent: templateGroup
            }"
    >
    </ng-container>
    <ng-container *ngIf="item.type !== 'SUB_TOTAL' && item.type !== 'EMPTY' && item.type !== 'HEADER'">
        <mat-expansion-panel
            [expanded]="expandAll || expandedPanels.has(item.name) ? true : collapseAll && touched ? false : undefined"
            hideToggle
            class="row-fli"
            [attr.data-fli-caption]="item.caption"
            [ngClass]="{
                'level-border-bottom': displayBorderBottom,
                'sub-fli': item.type === 'SUB FLI' || item.type === 'OF_THAT_ITEM'
            }"
        >
            <mat-expansion-panel-header (click)="togglePanel(item.name)">
                <mat-panel-title class="row-level">
                    <div class="column text-column">
                        <div class="name-padding-left"></div>
                        <ng-container *ngFor="let flisIndentation of flisLevelsIndentations">
                            <div class="level-indentation"></div>
                        </ng-container>

                        <span
                            *ngIf="item.accounts?.length > 0"
                            class="expanded-icon aumico-pattern-icon-arrow-down chevron-m"
                        >
                            <i class="chevron-icon"></i>
                        </span>
                        <span
                            *ngIf="item.accounts?.length > 0"
                            class="collapsed-icon aumico-pattern-icon-arrow-right chevron-m"
                        >
                            <i class="chevron-icon"></i>
                        </span>
                        <span
                            class="of-that-item-ellipsis"
                            *ngIf="item.type === 'OF_THAT_ITEM'"
                            (click)="mapSelectedAccounts(item, parentGroup, parentFli, $event)"
                        >
                            {{
                                'aumico_templates_group_account_mapping_of_that_item_text'
                                    | i18nextWithLocale : reportLocale
                            }}
                        </span>
                        <div
                            (click)="mapSelectedAccounts(item, parentGroup, parentFli, $event)"
                            style="overflow: hidden"
                        >
                            <div class="text-overflow" [class.display-none]="item.type === 'FLI'">
                                <inline-table-cell-edit
                                    (save)="changeItemCaption(item, $event)"
                                    [value]="item.caption"
                                    [type]="item.type"
                                    #subFliEditableCell
                                ></inline-table-cell-edit>
                            </div>

                            <div
                                [class.display-none]="item.type !== 'FLI'"
                                class="text-overflow fli-cell"
                                (click)="mapSelectedAccounts(item, parentGroup, parentFli, $event)"
                            >
                                <div class="fli-name-with-icon">
                                    <span ellipsis>
                                        {{ item.caption }}
                                    </span>
                                    <span
                                        *ngIf="
                                            item.name === profitOfTheYearFliName &&
                                            isAutomaticTransferOfAnnualResultEnabled
                                        "
                                        hamTooltip="{{
                                            'aumico_templates_group_account_mapping_mapping_to_profit_fli_disabled_tooltip_text'
                                                | i18next
                                        }}"
                                        [withArrow]="true"
                                        class="ham-icon"
                                    >
                                        <i class="lock-icon"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        (click)="mapSelectedAccounts(item, parentGroup, parentFli, $event)"
                        class="column value-column closing-column"
                    >
                        <span class="value-column-cell-value"> {{ item.calculatedClosingBalance | finNumber }}</span>
                    </div>
                    <div
                        (click)="mapSelectedAccounts(item, parentGroup, parentFli, $event)"
                        class="column value-column"
                    >
                        <span *ngIf="errorInProfitFli && item.name === profitOfTheYearFliName" class="ham-icon">
                            <i class="exclamation-outline-icon"></i>
                        </span>
                        <span
                            *ngIf="!errorInProfitFli || item.name !== profitOfTheYearFliName"
                            class="value-column-cell-value"
                            >{{ item.calculatedOpeningBalance | finNumber }}</span
                        >
                    </div>
                    <div class="column action-column action-column-padding">
                        <span class="action-column__container">
                            <ng-container *ngIf="item.type !== 'SUB FLI' && item.type !== 'OF_THAT_ITEM'">
                                <mat-icon
                                    *ngIf="
                                        templateGroup.sortedItems.length > 1 &&
                                        itemIndex !== templateGroup.sortedItems.length - 1
                                    "
                                    class="move-icon"
                                    (click)="moveGroupItem(item, false, $event)"
                                    >south</mat-icon
                                >
                                <mat-icon
                                    *ngIf="templateGroup.sortedItems.length > 1 && itemIndex !== 0"
                                    class="move-icon"
                                    (click)="moveGroupItem(item, true, $event)"
                                    >north</mat-icon
                                >
                                <span
                                    *ngIf="isGroupItemDeletable(item)"
                                    class="aumico-pattern-icon-remove"
                                    (click)="removeItem(item, $event)"
                                >
                                    <i></i>
                                </span>
                                <menu-list-for-mapping
                                    [item]="item"
                                    [isAddAccountDisabled]="
                                        item.name === profitOfTheYearFliName && isAutomaticTransferOfAnnualResultEnabled
                                    "
                                    [businessModel]="businessModel"
                                    (onClickEmitter)="onMenuActionClicked($event, item, parentGroup, itemIndex)"
                                ></menu-list-for-mapping>
                            </ng-container>
                            <ng-container *ngIf="item.type === 'SUB FLI' || item.type === 'OF_THAT_ITEM'">
                                <div class="action-column__container">
                                    <mat-icon
                                        *ngIf="
                                            parentFli.accounts.length > 1 && itemIndex !== parentFli.accounts.length - 1
                                        "
                                        class="move-icon"
                                        (click)="moveGroupItem(item, false, $event, parentFli)"
                                        >south</mat-icon
                                    >
                                    <mat-icon
                                        *ngIf="parentFli.accounts.length > 1 && itemIndex !== 0"
                                        class="move-icon"
                                        (click)="moveGroupItem(item, true, $event, parentFli)"
                                        >north</mat-icon
                                    >
                                    <!-- To remove the sub-fli from the fli -->
                                    <span
                                        class="aumico-pattern-icon-remove"
                                        (click)="removeAccountFrom(parentFli, itemIndex)"
                                    >
                                        <i></i>
                                    </span>
                                    <menu-list-for-mapping
                                        [item]="item"
                                        [businessModel]="businessModel"
                                        [cellComponent]="subFliEditableCell"
                                        (onClickEmitter)="onMenuActionClicked($event, item, parentFli, itemIndex)"
                                    ></menu-list-for-mapping>
                                </div>
                            </ng-container>
                        </span>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div cdkDropList (cdkDropListDropped)="drop($event, item)">
                <div *ngFor="let account of item.accounts; index as accountIndex" cdkDrag [cdkDragDisabled]="true">
                    <ng-container
                        *ngIf="
                            account.type !== 'SUB FLI' &&
                            account.type !== 'OF_THAT_ITEM' &&
                            account.type !== 'EMPTY' &&
                            account.type !== 'HEADER'
                        "
                    >
                        <ng-container
                            [ngTemplateOutlet]="accountTemplate"
                            [ngTemplateOutletContext]="{
                                item: item,
                                account: account,
                                accountIndex: accountIndex,
                                flisLevelsIndentations: flisLevelsIndentations
                            }"
                        >
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="account.type === 'SUB FLI' || account.type === 'OF_THAT_ITEM'">
                        <ng-container
                            [ngTemplateOutlet]="subFli"
                            [ngTemplateOutletContext]="{
                                subFliItem: account,
                                expandAll: expandAll,
                                collapseAll: collapseAll,
                                parentFli: item,
                                itemIndex: accountIndex,
                                flisLevelsIndentations: flisLevelsIndentations,
                                displayBorderBottom: item.accounts.length - 1 !== accountIndex
                            }"
                        >
                        </ng-container>
                    </ng-container>
                    <ng-container
                        *ngIf="account.type === 'EMPTY'"
                        [ngTemplateOutlet]="emptyRow"
                        [ngTemplateOutletContext]="{
                            item: account,
                            index: accountIndex,
                            parent: item
                        }"
                    >
                    </ng-container>
                    <ng-container
                        *ngIf="account.type === 'HEADER'"
                        [ngTemplateOutlet]="header"
                        [ngTemplateOutletContext]="{
                            item: account,
                            index: accountIndex,
                            parent: item
                        }"
                    >
                    </ng-container>
                </div>
            </div>
        </mat-expansion-panel>
    </ng-container>
</ng-template>

<ng-template
    #subFli
    let-subFliItem="subFliItem"
    let-expandAll="expandAll"
    let-collapseAll="collapseAll"
    let-parentFli="parentFli"
    let-itemIndex="itemIndex"
    let-flisLevelsIndentations="flisLevelsIndentations"
    let-displayBorderBottom="displayBorderBottom"
>
    <div class="d-flex">
        <div class="name-padding-left"></div>
        <ng-container *ngFor="let flisIndentation of flisLevelsIndentations">
            <div class="level-indentation"></div>
        </ng-container>
        <ng-container
            [ngTemplateOutlet]="allItemsTemplate"
            [ngTemplateOutletContext]="{
                item: subFliItem,
                expandAll: expandAll,
                itemIndex: itemIndex,
                collapseAll: collapseAll,
                parentFli: parentFli,
                flisLevelsIndentations: [],
                displayBorderBottom: displayBorderBottom
            }"
        >
        </ng-container>
    </div>
</ng-template>
<ng-template #emptyRow let-item="item" let-parent="parent" let-index="index">
    <div class="column action-column-padding empty-row">
        <div class="empty-row__actions">
            <span class="aumico-pattern-icon-remove" (click)="removeItem(item, $event)">
                <i></i>
            </span>

            <menu-list-for-mapping
                [item]="item"
                [businessModel]="businessModel"
                (onClickEmitter)="onMenuActionClicked($event, item, parent, index)"
            ></menu-list-for-mapping>
        </div>
    </div>
</ng-template>

<ng-template #header let-item="item" let-parent="parent" let-index="index">
    <div class="header-item" *ngIf="savedHeadersNames.has(item.name) || item.header; else headerForm">
        <div class="name-padding-left"></div>
        <span> {{ item.caption || item.header }}</span>
        <div class="header-item__values-actions">
            <span class="aumico-pattern-icon-remove" (click)="removeItem(item, $event)">
                <i></i>
            </span>

            <menu-list-for-mapping
                [item]="item"
                [businessModel]="businessModel"
                (onClickEmitter)="onMenuActionClicked($event, item, parent, index)"
            ></menu-list-for-mapping>
        </div>
    </div>
    <ng-template #headerForm>
        <div #headerList [id]="item.name + index">
            <header-form
                [(headerCaption)]="item.caption"
                (saveHeaderCaption)="onSaveHeaderCaption($event, item)"
                (eraseHeaderForm)="removeItem(item, $event)"
            ></header-form>
        </div>
    </ng-template>
</ng-template>
